import upstreamApi from '@/api/upstreamApi.js'
import classifyApi from '@/api/classify.js'
import agentApi from '@/api/agent.js'
import userApi from '@/api/userApi.js'
import productApi from '@/api/product.js'
import cardProApi from '@/api/cardPro.js'
let Decimal = require('decimal.js')
const baseTools = {
  AccAdd(arg1, arg2) {
    return new Decimal(arg1).add(new Decimal(arg2)).toNumber()
  },
  AccSub(arg1, arg2) {
    return new Decimal(arg1).sub(new Decimal(arg2)).toNumber()
  },
  TrimAll: function(str, isGlobal) {
    var result
    result = str ? str.replace(/(^\s+)|(\s+$)/g, '') : ''
    if (isGlobal.toLowerCase() === 'g') {
      result = result.replace(/\s/g, '')
    }
    return result
  },
  ParallelLoadScripts: function(scripts, callback) {
    if (typeof scripts !== 'object') {
      scripts = [scripts]
    }
    var HEAD = document.getElementsByTagName('head').item(0) || document.documentElement
    // eslint-disable-next-line
    var s = new Array()
    var loaded = 0
    for (var i = 0; i < scripts.length; i++) {
      s[i] = document.createElement('script')
      s[i].setAttribute('type', 'text/javascript')
      s[i].onload = s[i].onreadystatechange = function() {
        if (!0 || this.readyState === 'loaded' || this.readyState === 'complete') {
          loaded++
          this.onload = this.onreadystatechange = null
          this.parentNode.removeChild(this)
          if (loaded === scripts.length && typeof callback === 'function') callback()
        }
      }
      s[i].setAttribute('src', scripts[i])
      HEAD.appendChild(s[i])
    }
  },
  /**
   * 时间查询快捷选项
   * @param AddDayCount：-1：昨天，  0：今天， -7：近一周， -31：近一月， -92：近三月
   * @returns {{fullStartDate: string, fullEndDate: string}}
   * @constructor
   */
  GetQueryDate: function(AddDayCount) {
    var dd = new Date()
    dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
    var year = dd.getFullYear() // 获取当前年，四位数
    var month = dd.getMonth() + 1 // 获取当前月
    var day = dd.getDate() // 获取当前日
    var dateStartPart = year + '-'
    var dateEndPart = ''
    if (AddDayCount === -1) {
      dateEndPart = year + '-'
      if (month < 10) {
        dateEndPart += '0'
      }
      dateEndPart += month + '-'
      if (day < 10) {
        dateEndPart += '0'
      }
      dateEndPart += day
    } else {
      var mydate = new Date()
      var curyear = mydate.getFullYear()
      var curmonth = mydate.getMonth() + 1 // 获取当前月
      var curday = mydate.getDate() // 获取当前月
      dateEndPart = curyear + '-'
      if (curmonth < 10) {
        dateEndPart += '0'
      }
      dateEndPart += curmonth + '-'
      if (curday < 10) {
        dateEndPart += '0'
      }
      dateEndPart += curday
    }

    if (month < 10) {
      dateStartPart += '0'
    }
    dateStartPart += month + '-'
    if (day < 10) {
      dateStartPart += '0'
    }
    dateStartPart += day
    var fullStartDate = dateStartPart + ' ' + '00' + ':' + '00' + ':' + '00'
    var fullEndDate = dateEndPart + ' ' + '23' + ':' + '59' + ':' + '59'
    // var fullStartDate = dateStartPart ;
    // var fullEndDate = dateEndPart;

    return {
      fullStartDate,
      fullEndDate,
    }
  },
  GetQueryDateShort: function(AddDayCount) {
    var dd = new Date()
    dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
    var year = dd.getFullYear() // 获取当前年，四位数
    var month = dd.getMonth() + 1 // 获取当前月
    var day = dd.getDate() // 获取当前日
    var dateStartPart = year + '-'
    var dateEndPart = ''
    if (AddDayCount === -1) {
      dateEndPart = year + '-'
      if (month < 10) {
        dateEndPart += '0'
      }
      dateEndPart += month + '-'
      if (day < 10) {
        dateEndPart += '0'
      }
      dateEndPart += day
    } else {
      var mydate = new Date()
      var curyear = mydate.getFullYear()
      var curmonth = mydate.getMonth() + 1 // 获取当前月
      var curday = mydate.getDate() // 获取当前月
      dateEndPart = curyear + '-'
      if (curmonth < 10) {
        dateEndPart += '0'
      }
      dateEndPart += curmonth + '-'
      if (curday < 10) {
        dateEndPart += '0'
      }
      dateEndPart += curday
    }

    if (month < 10) {
      dateStartPart += '0'
    }
    dateStartPart += month + '-'
    if (day < 10) {
      dateStartPart += '0'
    }
    dateStartPart += day
    // var fullStartDate = dateStartPart + " " + "00" + ":" + "00" + ":" + "00";
    // var fullEndDate = dateEndPart + " " + "23" + ":" + "59" + ":" + "59";
    var fullStartDate = dateStartPart
    var fullEndDate = dateEndPart

    return {
      fullStartDate,
      fullEndDate,
    }
  },
  ErrorTipShow(vm, msg) {
    vm.$message({
      showClose: true,
      message: msg,
      type: 'error',
      offset: 300,
      center: true,
    })
  },
  SuccessTipShow(vm, msg, closeBackFn, time) {
    let msc = 2000
    if (time != null && time !== '' && time !== undefined) {
      msc = time
    }
    vm.$message({
      showClose: true,
      message: msg,
      type: 'success',
      duration: msc,
      offset: 300,
      center: true,
      onClose: () => {
        // 此处写提示关闭后需要执行的函数
        if (typeof closeBackFn === 'function') {
          closeBackFn()
        }
      },
    })
  },
  WarningTipShow(vm, msg) {
    vm.$message({
      showClose: true,
      message: msg,
      type: 'warning',
      offset: 300,
      center: true,
    })
  },
  getQuarterStartTime(paraYear, paraSeason) {
    switch (paraSeason) {
      case '1':
        return paraYear + '-01-01 00:00:00'
      case '2':
        return paraYear + '-04-01 00:00:00'
      case '3':
        return paraYear + '-07-01 00:00:00'
      case '4':
        return paraYear + '-10-01 00:00:00'
    }
  },
  getQuarterEndTime(paraYear, paraSeason) {
    switch (paraSeason) {
      case '1':
        return paraYear + '-03-31 23:59:59'
      case '2':
        return paraYear + '-06-30 23:59:59'
      case '3':
        return paraYear + '-09-30 23:59:59'
      case '4':
        return paraYear + '-12-31 23:59:59'
    }
  },
  getQuarterByDate() {
    var today = new Date()
    var year = today.getFullYear()
    var month = today.getMonth() + 1
    if (month >= 1 && month <= 3) {
      return year + '1'
    } else if (month >= 4 && month <= 6) {
      return year + '2'
    } else if (month >= 7 && month <= 9) {
      return year + '3'
    } else {
      return year + '4'
    }
  },
  checkPassword(password) {
    let passReg = /^(?![A-z]+$)(?!\d+$)(?![\W_]+$)^.{6,20}$/
    return passReg.test(password)
  },
  getUpStreamList(vm) {
    upstreamApi.getAllUpstream().then((res) => {
      vm.upstreamList = res
    })
  },
  /* 1:充值商户 2：卡密商户 */
  getDownStreamList(vm, memberType) {
    agentApi.getAll(memberType).then((res) => {
      vm.downstreamList = res
    })
  },
  getClassifyList(vm) {
    classifyApi.getAll().then((res) => {
      vm.classifyList = res
    })
  },
  getDealList(vm, needAll = false) {
    userApi.pullDown().then((res) => {
      vm.dealList = res
      if (needAll) {
        vm.dealList.unshift({ id: 0, name: '全部' })
      }
    })
  },
  getProductList(vm) {
    productApi.getAll().then((res) => {
      vm.productList = res
    })
  },
  getCardProList(vm) {
    cardProApi.getAll().then((res) => {
      vm.cardProList = res
    })
  },
}
export default baseTools



// WEBPACK FOOTER //
// ./src/utils/comFun.js